import React from "react"
// import { StaticImage } from "gatsby-plugin-image"//ローカルから画像を持ってくる
import { TitleAnimation } from '../index'
// import { LinkButton } from "../index"
// import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import * as styles from "./RecruitMessage.module.scss"
import styled from 'styled-components'
import bgImage from '../../images/recruit/top/message@2x.png'

const RecruitMessage = () => {

  // const breakpoints = useBreakpoint();

  const title1 = [
    { "id": 0, "text": "m" },
    { "id": 1, "text": "e" },
    { "id": 2, "text": "s" },
    { "id": 3, "text": "s" },
    { "id": 4, "text": "a" },
    { "id": 5, "text": "g" },
    { "id": 6, "text": "e" },
  ];

  return (
      <div className={styles.RecruitMessage}>
        <div className={styles.RecruitMessage__inner}>
          <TitleAnimation data={title1} className={`titleRubikCenter`} />
          <h2 className={`subH2`}>メッセージ</h2>
          <Div>
            <div className={styles.RecruitMessage__content}>
              <div className={styles.RecruitMessage__title}>
                <strong>喜び</strong>を<strong>創造</strong>する
              </div>
              <div className={styles.RecruitMessage__text}>
                深川養鶏は、<br/>
                お客様に喜んでいただけるだけでなく<br/>
                職員や生産者が喜んで働ける環境づくりを<br className={`smBr`}/>目指しています。<br/>
                新しいアイデアを出し合い、<br/>
                一緒に組織や地域を盛り上げていきましょう。
              </div>
            </div>
          </Div>
        </div>
      </div>
  )
}
export default RecruitMessage

const Div = styled.div`
  background: url(${bgImage}) center center;
  background-size: cover;
`